import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Form, Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Section } from '../../uiComponents/layout/Section';
import { TextFormGroup, RichTextFormGroup, MenuItemDto } from '../../uiComponents/input/FormGroups';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { EditorState } from 'draft-js';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import { KontaktSpoergsmaal } from '../../models/KontaktSpoergsmaal';
import DraftHelper from '../../infrastructure/DraftHelper';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import NotificationData from '../../uiComponents/layout/NotificationData';
import { Redirect } from 'react-router-dom';
import { Kommune } from '../../models/Kommune';
import HelperMethods from '../../infrastructure/HelperMethods';
import Autocomplete from '../../uiComponents/input/Autocomplete';

export interface KontaktContainerProps {
}

interface KontaktContainerState {
    editorState: EditorState;
    isSubmitting: boolean;
    validationResult: ValidationResult;
    isSaved: boolean;
    spoergsmaal: KontaktSpoergsmaal;
    kommuner: Kommune[];
}

export default class KontaktContainer extends React.Component<KontaktContainerProps, KontaktContainerState> {
    constructor(props: KontaktContainerState) {
        super(props);
        this.state = {
            editorState: DraftHelper.getEmptyEditorState(),
            isSubmitting: false,
            validationResult: new ValidationResult(),
            isSaved: false,
            spoergsmaal: new KontaktSpoergsmaal(),
            kommuner: []
        };
    }

    componentDidMount() {
        const apiCaller = createApiCaller();

        apiCaller.getKommuner().then(response => {
            let kommunerSorted = HelperMethods.sortKommuneByNavn(response);
            this.setState({ kommuner: kommunerSorted });
        });
    }

    onSave = () => {
        let self = this;
        this.setState({ isSubmitting: true });
        var notificationMessage = 'Din besked er nu sendt. Tak for din henvendelse.';
        const spoergsmaal = this.state.spoergsmaal;

        createApiCaller().createKontaktSpoergsmaal(spoergsmaal)
            .then(function (validationResult: ValidationResult) {
                self.onSpoergsmaalSaved(validationResult, notificationMessage);
            });
    }

    onSpoergsmaalSaved(validationResult: ValidationResult, notificationMessage: string) {
        this.setState({ validationResult: validationResult, isSaved: validationResult.isValid ? true : false, isSubmitting: false });
        if (validationResult.isValid) {
            NotificationQueue.push(new NotificationData(notificationMessage, '', 'success'));
        }
    }

    onKontaktFormChanged = (fieldName: string, value: any) => {
        let spoergsmaal = this.state.spoergsmaal;

        if (fieldName === 'skoleKommune') {
            // Ikke multiselect, hvorfor det altid er index 0
            spoergsmaal[fieldName] = value[0];
        } else {
            spoergsmaal[fieldName] = value;
        }

        this.setState({ spoergsmaal: spoergsmaal });
    }

    onOpgaveEditorChange = (editorState: EditorState) => {
        let spoergsmaal = this.state.spoergsmaal;
        if (spoergsmaal !== undefined) {
            spoergsmaal.tekst = DraftHelper.getEditorStateAsHtml(editorState);
        }

        this.setState({ editorState: editorState, spoergsmaal: spoergsmaal });
    }

    render() {
        const alleKommuner: MenuItemDto[] = this.state.kommuner.map(k => new MenuItemDto(k.nummer, k.navn));

        const valgtKommune: MenuItemDto[] = new Array();
        if (this.state.spoergsmaal.skoleKommune !== null) {
            const kommune = this.state.kommuner.find(x => x.nummer === this.state.spoergsmaal.skoleKommune);
            if (kommune !== undefined) {
                valgtKommune.push(new MenuItemDto(kommune.nummer, kommune.navn));
            }
        }
        
        if (this.state.isSaved) {
            return <Redirect to='/' />;
        }
        return (
            <PageWrapper className='laerervejledning-presenter'>
                <PageTitle title={'Support'} />
                <ContentWrapper>
                    <SectionGroup header='Kontakt os'>
                        <Form onSubmit={this.onSave}>
                            <Section>
                                <Row>
                                    <Col md={3} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Navn*'
                                            name='navn'
                                            placeholder='Skriv navn...'
                                            value={this.state.spoergsmaal.navn}
                                            onChange={this.onKontaktFormChanged}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Brugernavn*'
                                            name='brugernavn'
                                            placeholder='Skriv Unilogin brugernavn...'
                                            value={this.state.spoergsmaal.brugernavn}
                                            onChange={this.onKontaktFormChanged}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Email*'
                                            name='email'
                                            placeholder='Skriv email...'
                                            value={this.state.spoergsmaal.email}
                                            onChange={this.onKontaktFormChanged}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Telefonnummer*'
                                            name='telefonNummer'
                                            placeholder='Skriv telefonnummer...'
                                            value={this.state.spoergsmaal.telefonNummer}
                                            onChange={this.onKontaktFormChanged}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            <Section>
                                <Row>
                                    <Col md={3} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Skolens navn*'
                                            name='skoleNavn'
                                            placeholder='Skriv skolens navn...'
                                            value={this.state.spoergsmaal.skoleNavn}
                                            onChange={this.onKontaktFormChanged}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Autocomplete
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Skolens kommune*'
                                            name='skoleKommune'
                                            placeholder='Angiv skolens kommune...'
                                            selected={valgtKommune}
                                            onChange={this.onKontaktFormChanged}
                                            data={alleKommuner}
                                            multiple={false}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Din funktion*'
                                            name='funktion'
                                            placeholder='...'
                                            value={this.state.spoergsmaal.funktion}
                                            onChange={this.onKontaktFormChanged}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            <Section>
                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <TextFormGroup
                                            errorMessages={this.state.validationResult.errorMessages}
                                            label='Emne*'
                                            name='emne'
                                            placeholder='Skriv skolens emne...'
                                            value={this.state.spoergsmaal.emne}
                                            onChange={this.onKontaktFormChanged}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} mdOffset={3}>
                                        <RichTextFormGroup
                                            onEditorChange={(editorState: EditorState) => this.onOpgaveEditorChange(editorState)}
                                            editorState={this.state.editorState}
                                        />
                                    </Col>
                                </Row>
                            </Section>
                            <ButtonSection>
                                <SubmitButton isSubmitting={this.state.isSubmitting}>Send spørgsmål</SubmitButton>
                            </ButtonSection>
                        </Form>

                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/kontakt/KontaktContainer.tsx